import { isSameDay } from '@/components/Calendar/calendarUtils';

export const groupItemsByDate = <T>(
  items: T[],
  getDate: (item: T) => Date,
): { date: Date; items: T[] }[] => {
  const groups: { date: Date; items: T[] }[] = [];
  for (const item of items) {
    const date = getDate(item);
    const existing = groups.find((g) => isSameDay(g.date, date));
    if (existing) existing.items.push(item);
    else groups.push({ date, items: [item] });
  }
  return groups;
};

export const groupByDate = <T>(items: T[], getDate: (item: T) => string): Record<string, T[]> => {
  return items.reduce(
    (acc, item) => {
      const dateKey = getDate(item);

      if (!acc[dateKey]) {
        acc[dateKey] = [];
      }

      acc[dateKey].push(item);

      return acc;
    },
    {} as Record<string, T[]>,
  );
};
